import { Link } from "react-router-dom";
import { 
  Building2, 
  Users, 
  LayoutDashboard, 
  Settings, 
  Shield,
  CreditCard,
  FileText,
  BarChart,
  Calendar,
  Wifi,
  MessageSquare
} from "lucide-react";
import { cn } from "@/lib/utils";

interface MenuItem {
  icon: any;
  label: string;
  path: string;
}

export const getMenuItems = (role: string): MenuItem[] => {
  const items = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/" },
    { icon: Building2, label: "Imóveis", path: "/imoveis" },
    { icon: Users, label: "Proprietários", path: "/proprietarios" },
    { icon: Calendar, label: "Agendamentos", path: "/agendamentos" },
    { icon: Wifi, label: "Conexão", path: "/conexao" },
    { icon: MessageSquare, label: "Mensagens", path: "/mensagens" },
    { icon: FileText, label: "Relatórios", path: "/relatorios" },
    { icon: Settings, label: "Configurações", path: "/configuracoes" },
  ];

  if (role === 'super-admin') {
    items.push({ icon: Shield, label: "Super Admin", path: "/super-admin" });
  }

  return items;
};

interface MenuItemsProps {
  role: string;
  currentPath: string;
  onItemClick?: () => void;
}

export const MenuItems = ({ role, currentPath, onItemClick }: MenuItemsProps) => {
  const items = getMenuItems(role);

  return (
    <nav className="p-4 space-y-2">
      {items.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          onClick={onItemClick}
          className={cn(
            "flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors",
            currentPath === item.path
              ? "bg-primary text-white"
              : "text-gray-600 hover:bg-gray-100"
          )}
        >
          <item.icon size={20} />
          <span className="font-medium">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};